import YesNoModal from './YesNoModal';

export default YesNoModal;
